<template>
  <v-app>
    <navigation
      v-if="userIsAuthenticated && $route.name != 'recentdashboard'"
    ></navigation>

    <v-content
      :class="{
        'app-people-bg': $route.name === 'recentdashboard',
      }"
    >
      <ContentStatusMessageContainer
        v-if="userIsAuthenticated"
      ></ContentStatusMessageContainer>
      <router-view></router-view>
    </v-content>

    <v-snackbar
      auto-height
      :timeout="snackbar.timeout"
      :top="snackbar.y === 'top'"
      :bottom="snackbar.y === 'bottom'"
      :right="snackbar.x === 'right'"
      :left="snackbar.x === 'left'"
      :multi-line="snackbar.mode === 'multi-line'"
      :vertical="snackbar.mode === 'vertical'"
      v-model="snackbar.visible"
      :color="snackbar.messageType"
    >
      <div v-html="snackbar.message"></div>
      <v-btn flat color="white" @click.native="snackbar.visible = false">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Navigation from "@/components/Navigation";
import ContentStatusMessageContainer from "@/components/ContentStatusMessage";

export default {
  name: "App",
  components: {
    Navigation,
    ContentStatusMessageContainer,
  },
  data() {
    return {
      showUpdateUI: false,
    };
  },
  computed: {
    userIsAuthenticated: function () {
      return this.$store.state.userIsAuthenticated;
    },
    snackbar() {
      return this.$store.state.snackbar;
    },
  },
  methods: {
    async updateApp() {
      this.showUpdateUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
  },
  created() {
    if (this.$workbox) {
      const that = this;
      this.$workbox.addEventListener("waiting", () => {
        that.showUpdateUI = true;
        that.updateApp();
      });
    }
  },
};
</script>

<style>
@import "./assets/styles/main.css";
</style>